// services/subscriptionService.js
const API_URL = process.env.REACT_APP_API_URL;

export const subscriptionService = {
  async createCheckoutSession(companyId) {
    try {
      const response = await fetch(
        `${API_URL}/api/subscription/create-checkout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ companyId }),
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating checkout session:", error);
      throw error;
    }
  },

  /**
   * Create Paystack checkout session
   */
  async createPaystackCheckoutSession(companyId) {
    try {
      const response = await fetch(
        `${API_URL}/api/subscription/create-paystack-checkout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ companyId }),
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating Paystack checkout session:", error);
      throw error;
    }
  },

  /**
   * Create Revolut checkout session (recurring subscription).
   * currency defaults server-side to REVOLUT_CURRENCY/GBP if omitted.
   */
  async createRevolutCheckoutSession(companyId, currency) {
    try {
      const response = await fetch(
        `${API_URL}/api/subscription/create-revolut-checkout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ companyId, ...(currency ? { currency } : {}) }),
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating Revolut checkout session:", error);
      throw error;
    }
  },

  /**
   * Get subscription status
   */
  async getSubscriptionStatus() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/subscription/status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error getting subscription status:", error);
      throw error;
    }
  },

  /**
   * Get company details with users
   */
  async getCompanyDetails() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/subscription/company`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error getting company details:", error);
      throw error;
    }
  },

  /**
   * Create customer portal session
   */
  async createPortalSession() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/subscription/portal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating portal session:", error);
      throw error;
    }
  },

  /**
   * Cancel subscription
   */
  async cancelSubscription() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/subscription/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error canceling subscription:", error);
      throw error;
    }
  },
};